module.exports = __webpack_public_path__ + "img/广枣.f5ab8d21.jpg";